import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { PartnershipValidation } from '@models/swagger';
import {
  PartnershipValidationStepFailure,
  PartnershipValidationStepRequest,
  PartnershipValidationStepReset,
  PartnershipValidationStepSuccess,
} from './actions';

export const featureKey = 'partnershipValidationStep';

export interface State {
  data: PartnershipValidation | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(PartnershipValidationStepFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(PartnershipValidationStepRequest, state => ({ ...state, error: null, loading: true })),
    on(PartnershipValidationStepSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false })),
    on(PartnershipValidationStepReset, state => ({ ...state, data: null }))
  )(state, action);
}
